import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class MotivosRechazo {
  static getMotivos () {
    const axios = getAxiosInstance()
    const promise = axios.get(`rechazo_en_pesado`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }
}

export default MotivosRechazo
